import FilePreviewComponent from '@/components/probaworkflows_base_components/FilePreviewComponent/FilePreviewComponent.vue';
import NavigationBackButton from "@/components/probaworkflows_base_components/NavigationBackButton/NavigationBackButton.vue";
import {
    get_headers,
    VIEW_SINGLE_REQUEST_INFO_URL,
} from '@/utils/constants/constants';
import alert_mixin from '@/utils/mixins/alert_mixin';
import axios from 'axios';

export default {
    name: 'ResolvedRequests',
    mixins: [alert_mixin],
    components: { NavigationBackButton, FilePreviewComponent },

    data: () => ({
        request_note: '',
        is_resolved: '',
        date_requested: '',
        requester_name: '',
        headers: {},
        fields: [],
        request_id: '',
        request_response: {},
        token: "",
        is_loading: false,
        history: [],
        selected_file: '',
        submitted_documents: [],
        request_infomation: {},
        preview_modal: false

    }),

    mounted() {
        this.headers = get_headers();
        this.request_id = this.$route.query.request_id;
        this.get_request();
    },


    methods: {
        get_request() {
            axios.get(VIEW_SINGLE_REQUEST_INFO_URL, {
                headers: this.headers,
                params: {
                    request_id: parseInt(this.request_id, 10),
                }
            })
                .then(response => {
                    const response_data = response.data;

                    if (response_data.data.length > 0) {
                        var request_info = response_data.data[0];
                        this.request_infomation = request_info;

                        if (request_info.requested_fields?.length) {
                            this.fields = request_info.requested_fields.map(field => ({
                                question_id: field.requested_field_id,
                                label: field.requested_field_text,
                                section_id: field.form_section_id,
                            }));
                        }
                        if (request_info.responses?.length) {
                            this.submitted_documents = request_info.responses.map(request_response => ({
                                document_id: request_response.id,
                                presigned_url: request_response.presigned_url,
                                name: request_response.document_name ||
                                    request_response.file_name ||
                                    request_response.original_filename ||
                                    this.extract_file_name_from_url(request_response.presigned_url) ||
                                    'Document ' + request_response.id,
                                response_accepted: request_response.response_accepted,
                                response_rejected: request_response.response_rejected,
                                review_status: request_response.response_accepted
                                    ? "Approved"
                                    : request_response.response_rejected
                                        ? "Rejected"
                                        : "Pending Review",
                                date_created: request_response.date_created,
                                section_id: request_response.form_section_id,
                            }));
                        }
                    }
                })
                .catch(error => {
                    if (error.response && error.response.data) {
                        this.show_error(error.response.data.message);
                    }
                });
        },

        extract_file_name_from_url(url) {
            if (!url) return 'Document';
            const decoded = decodeURIComponent(url);
            const matches = decoded.match(/\/([^/?]+)(?=\?|$)/);
            return matches ? matches[1] : 'Document';
        },

        open_document(document) {
            this.selected_file = document;
            this.preview_modal = true
        },
        close_the_file_preview() {
            this.preview_modal = false;
            // Optional: reset the selected_url if needed
            this.selected_file = null;
        },
    }

}